module.exports = __webpack_public_path__ + "static/frybread-zoom-e042e9db87b09389e2bedb90b6845a81.jpg";